import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Compass, Ticket, Sparkles } from "lucide-react";
import { useI18n } from "@/i18n";

export const MobileTabBar = () => {
  const { t } = useI18n();
  const location = useLocation();

  const tabClass = (active) =>
    `flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-[11px] font-medium transition-colors ${
      active ? "text-primary" : "text-muted-foreground"
    }`;

  const openAI = () => window.dispatchEvent(new CustomEvent("open-ai-assistant"));

  return (
    <nav
      data-testid="mobile-tabbar"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden glass border-t border-black/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch">
        <NavLink to="/" end data-testid="tab-home" className={({ isActive }) => tabClass(isActive)}>
          <Home className="h-5 w-5" /> {t("explore")}
        </NavLink>
        <NavLink to="/activities" data-testid="tab-activities" className={({ isActive }) => tabClass(isActive)}>
          <Compass className="h-5 w-5" /> {t("nav_activities")}
        </NavLink>
        <NavLink to="/dashboard" data-testid="tab-trips" className={({ isActive }) => tabClass(isActive)}>
          <Ticket className="h-5 w-5" /> {t("nav_dashboard")}
        </NavLink>
        <button type="button" onClick={openAI} data-testid="tab-ai" className={tabClass(false)}>
          <Sparkles className="h-5 w-5" /> AI
        </button>
      </div>
    </nav>
  );
};
